export enum LogoVariant {
  DEFAULT,
  WHITE,
}
